import {ResourcesConfig} from 'aws-amplify';
import {config as API} from './api';
import {config as Auth} from './auth';

export const config = {
    Auth: Auth,
    API: {
        REST: API
    }
} as ResourcesConfig;